import React from 'react';

interface RecordsTableCardProps {
  title: string;
  description?: React.ReactNode;
  eyebrow?: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  toolbar?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  tableLabel?: string;
}

const joinClasses = (...classes: Array<string | undefined | false>) =>
  classes.filter(Boolean).join(' ');

const RecordsTableCard: React.FC<RecordsTableCardProps> = ({
  title,
  description,
  eyebrow,
  meta,
  actions,
  toolbar,
  footer,
  children,
  className,
  tableLabel,
}) => (
  <section className={joinClasses('records-card', className)} aria-label={tableLabel || title}>
    <div className="records-card-header">
      <div className="records-card-heading">
        {eyebrow ? <span className="records-card-eyebrow">{eyebrow}</span> : null}
        <div className="records-card-title-row">
          <h2>{title}</h2>
          {meta ? <span className="records-card-meta">{meta}</span> : null}
        </div>
        {description ? <p>{description}</p> : null}
      </div>
      {actions ? <div className="records-card-actions">{actions}</div> : null}
    </div>
    {toolbar ? <div className="records-card-toolbar">{toolbar}</div> : null}
    <div className="records-table-wrap">
      {children}
    </div>
    {footer ? <div className="records-card-footer">{footer}</div> : null}
  </section>
);

export default RecordsTableCard;
